// extracted by mini-css-extract-plugin
export var aniSpin = "n_d";
export var el = "n_b";